<script setup>
defineProps({
    color: {
        type: String,
        default: 'primary'
    }
});
</script>

<template>
    <v-card-text class="text-center">
        <v-progress-circular
            :size="70"
            :width="7"
            :color="color"
            indeterminate
            transition="fade-transition"
            class="my-6"
        ></v-progress-circular>
    </v-card-text>
</template>
